import React from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Fire, Time, Tools } from '../../services'

import { Card, CardHeader, CardBody } from 'reactstrap'
import { Headerbar, Loader, ConfirmButton, ListContainer } from '../Reusable'
import AdsList from '../Admin/Ads/AdsList'

import FadeIn from 'react-fade-in';
 
const { useHistory } = require('react-router-dom')

interface Props {
  match: any;
}
const ProSetupSuccess: React.FC<Props> = (props) => {

  const history = useHistory()

  const status = props.match.params.status
  const success = status === 'success'

  return (

    <div className="wrapper">
      <Headerbar
        title={"Votre compte"}
        />

      <div className="content-wrapper">
        <div className="content">
          <div className="container-fluid settings">

            <FadeIn>
              <Card>
                <CardHeader>
                  <i className="fa fa-align-justify"></i> {success ? 'Compte configuré' : 'Echec de la configuration'}
                </CardHeader>
                <CardBody>
                  {success ? 'Votre compte a été correctement configuré et vous pouvez désormais recevoir vos virements automatiquement.' : "Nous n'avons pas pu configuré votre compte correctement, veuillez ré-essayer ou contacter l'assistance Pop Out"} 
                </CardBody>
              </Card>
            </FadeIn>
          </div>
        </div>
      </div>

    </div>
  )
}

export default withRouter(ProSetupSuccess)